<div class="mixitup-page-list">
    <ng-container *ngFor="let x of buttons">
      <ng-container [ngSwitch]="x">
        <a *ngSwitchCase="'ellipsis'" class="no-loader">&hellip;</a>
        <a *ngSwitchCase="'previous'" class="no-loader mixitup-control mixitup-control-prev {{ prevDisabled() }}" (click)="pageChanged(page - 1)">
            <span [innerHTML]="leftArrow"></span>
            <p>Previous</p> 
        </a>
        <a *ngSwitchCase="'next'" class="no-loader mixitup-control mixitup-control-next {{ nextDisabled() }}" (click)="pageChanged(page + 1)">            
            <p>Next</p>
            <span [innerHTML]="rightArrow"></span>
        </a>
        <a *ngSwitchDefault class="no-loader mixitup-control {{ buttonDisabled(x) }}" (click)="pageChanged(x)">&nbsp;{{x}}&nbsp;</a>
      </ng-container>
    </ng-container>
  </div>